<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';

    import s from './sticky-notification.module.css';
</script>

<div class={cn(s.stickyRoot, { [s.desktop]: $globalStore.isDesktopSite })} data-testid='stickyNotification'>
    <slot />
</div>
